<template>
  <div>
    <esg-table-without-meta :items="items"
                            :fields="fields"
                            max-height="450px"
                            size="xs">
    </esg-table-without-meta>
  </div>
</template>
<script>
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  components: {EsgTableWithoutMeta},
  props: {
    corporation: {
      type: Object,
      default() {
        return {}
      }
    },
    businessLocation: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  watch: {
    corporation: {
      deep: true,
      handler() {
        this.fetchData();
      }
    },
    businessLocation: {
      deep: true,
      handler() {
        this.fetchData();
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let args = {
          groupKeys: [
            'abatement_method_value',
            'abatement_method_name',
            'abatement_method_type',
            'abatement_method_type_name',
            'cost_type'
          ]
        };
        this.corporation.name && (args.corporations = [this.corporation.code])
        this.businessLocation.name && (args.businessLocations = [this.businessLocation.business_location_code])

        let data = new FormData()
        data.append('path', 'esg/cost/main');
        data.append('json', JSON.stringify([args]));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: {Authorization: accessToken()},
          signal: this.abortController.signal
        });

        // If there is no data, return
        if (!response.data.data) {
          return;
        }

        // Parse JSON data
        let tableData = JSON.parse(response.data.data)[0].data;

        tableData = this.manipulateData(tableData);

        // Calculate total and push it to the items
        this.items = tableData;
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    manipulateData(data) {
      // Unique abatement methods
      let methods = new Set(data.map(row => row.abatement_method_type));

      // Construct new data
      const newData = [];
      for (let method of methods) {
        const filtered = data.filter(row => row.abatement_method_type === method);
        const capex = filtered.find(row => row.cost_type === 'C');
        const opex = filtered.find(row => row.cost_type === 'O');

        let newRow = {}
        newRow.abatement_method_type_name = filtered[0].abatement_method_type_name;
        newRow.capex = capex ? capex.cost_total : 0;
        newRow.opex = opex ? opex.cost_total : 0;
        newRow.cost_total = newRow.capex + newRow.opex;
        newRow.reduction_total = (capex ? capex.reduction_total : 0) + (opex ? opex.reduction_total : 0);
        newRow.unit_abatement_cost = newRow.cost_total / newRow.reduction_total;

        newData.push(newRow);
      }
      return newData;
    }
  },
  data() {
    return {
      loading: false,
      total: 0,
      items: [],
      fields: [
        {
          name: 'abatement_method_type_name',
          label: '감축수단',
          list: true
        },
        {
          name: 'reduction_total',
          label: '감축량 총합 (tCO2)',
          list: true,
          formatter: val => this.formatNumber(val, 0)
        },
        {
          name: 'capex',
          label: '투자비(CAPEX)',
          list: true,
          sortable: true,
          formatter: val => val ? this.formatNumber(val / 10e8, 0) : '-',
        },
        {
          name: 'opex',
          label: '운영비(OPEX)',
          list: true,
          sortable: true,
          formatter: val => val ? this.formatNumber(val / 10e8, 0) : '-'
        },
        {
          name: 'cost_total',
          label: '비용 총합 (억원)',
          list: true,
          sortable: true,
          formatter: val => val ? this.formatNumber(val / 10e8, 0) : '-'
        },
        {
          name: 'unit_abatement_cost',
          label: '톤당 감축비용(원/tCO2)',
          list: true,
          sortable: true,
          formatter: val => val === Infinity ? '-' : this.formatNumber(val, 0)
        },
      ]
    }
  },
}
</script>